import { StatusColor } from '@enums/status-color.enum';
import { ContractStatus } from '@gi/enums/contract-status.enum';

export const CONTRACT_STATUS_COLOR: Record<ContractStatus, StatusColor> = {
  [ContractStatus.draft]: StatusColor.grey3,
  [ContractStatus.sent]: StatusColor.orange,
  [ContractStatus.signed]: StatusColor.accent,
  [ContractStatus.lost]: StatusColor.warn
};
